import { type InsuranceCorporateIdentity } from "../types";

export function MieleLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M145.163 222.318H183.839V233.023H176.242V276.878H183.839V287.583H133.422V276.878H141.019V248.217L112.703 287.583L84.0422 248.217V276.878H91.6391V287.583H64.0138V276.878H71.6108V233.023H64.0138V222.318H107.869L126.516 247.871L145.163 222.318Z"
        fill="white"
      />
      <path
        d="M232.874 238.548H190.745V249.253H198.342V276.878H190.745V287.583H240.816V276.878H233.219V238.548H232.874ZM226.658 228.879L221.824 219.21L205.939 227.498L210.773 237.166L226.658 228.879Z"
        fill="white"
      />
      <path
        d="M275.348 258.231H286.052V251.324C286.052 249.253 284.326 245.799 280.527 245.799C277.074 245.799 275.348 248.907 275.348 250.979V258.231ZM275.348 266.864V272.043C275.348 276.187 279.146 279.986 285.016 279.986C293.649 279.986 297.103 273.425 297.793 270.662C307.117 270.662 314.368 270.662 317.131 270.662C314.368 279.64 302.628 290 280.873 290C252.557 290 243.924 274.806 243.924 263.065C243.924 250.634 254.283 235.785 280.873 235.785C304.009 235.785 317.822 249.253 317.822 263.065C317.822 265.482 317.476 266.864 317.476 266.864H275.348Z"
        fill="white"
      />
      <path
        d="M328.526 276.878H320.929V287.583H372.382V276.878H364.785V222.318H320.929V233.023H328.526V276.878Z"
        fill="white"
      />
      <path
        d="M407.259 258.231H417.963V251.324C417.963 249.253 416.237 245.799 412.438 245.799C408.985 245.799 407.259 248.907 407.259 250.979V258.231ZM407.259 266.864V272.043C407.259 276.187 411.057 279.986 416.927 279.986C425.56 279.986 429.014 273.425 429.704 270.662C439.028 270.662 446.279 270.662 449.042 270.662C446.279 279.64 434.539 290 412.784 290C384.468 290 375.835 274.806 375.835 263.065C375.835 250.634 386.194 235.785 412.784 235.785C435.92 235.785 449.733 249.253 449.733 263.065C449.733 265.482 449.387 266.864 449.387 266.864H407.259Z"
        fill="white"
      />
    </svg>
  );
}

export const Miele: InsuranceCorporateIdentity = {
  id: "miele",
  name: "Miele BKK",
  logo: MieleLogo,
  backgroundColor: "#A60D1F",
  textColor: "#FFFFFF",
  wildcard: "miele",
  type: "statutory",
};
